export default function EntregasEfetivas() {
  return (
    <section className="bg-[url(../assets/verticais-mobile.png)] md:bg-[url(../assets/verticais.png)] bg-cover bg-center bg-no-repeat bg-[rgb(23,14,80)] text-white pt-32 pb-56 relative overflow-hidden">
      <div className="container mx-auto xl:max-w-6xl">
        <div className="bg-[#192024)] relative">
          <h2 className="text-4xl md:text-6xl text-center block z-20 relative">
            Seus negócios precisam de entregas efetivas,{' '}
            <br className="md:hidden" />
            <span className="bg-gradient-to-r from-[#FC0021] via-[#910CCE] to-[#5534D9] text-transparent bg-clip-text">
              com resultados reais?
            </span>
          </h2>
        </div>
      </div>
    </section>
  )
}
